import { defineMessages } from 'react-intl';

export const dialogMessages = defineMessages({
  title: {
    id: 'core.docLinksGraph.title',
    defaultMessage: 'Document links',
  },
});

export const graphMessages = defineMessages({
  open: {
    id: 'core.docLinksGraph.open',
    defaultMessage: 'Open document',
  },
  changeEdges: {
    id: 'core.docLinksGraph.changeEdges',
    defaultMessage: 'Rebuild edges',
  },
  expand: {
    id: 'core.docLinksGraph.expand',
    defaultMessage: 'Expand category',
  },
  collapse: {
    id: 'core.docLinksGraph.collapse',
    defaultMessage: 'Collapse category',
  },
  description: {
    id: 'core.docLinksGraph.data.description',
    defaultMessage: 'No document description',
  },
  documentsCount: {
    id: 'core.docLinksGraph.documentsCount',
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
  },
});
